import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Link } from "react-router-dom";

const STATUSES = ["new", "contacted", "converted", "archived"];

export default function AdminPlans() {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState("");
  const [detail, setDetail] = useState(null);
  const load = () => api.get("/admin/plans", { params: status ? { status } : {} }).then((r) => setRows(r.data.items || []));
  useEffect(() => { load(); }, [status]);
  const open = async (plan_id) => { const r = await api.get(`/admin/plans/${plan_id}`); setDetail(r.data); };
  const setStat = async (plan_id, s) => { await api.post(`/admin/plans/${plan_id}/status`, { status: s }); toast.success("Updated"); load(); if (detail?.plan_id === plan_id) open(plan_id); };
  return (
    <div data-testid="admin-plans-page">
      <div className="flex items-baseline justify-between mb-6">
        <div><h1 className="font-serif text-3xl text-ivy tracking-tight">Plans</h1><p className="text-sm text-stone mt-1">{rows.length} plans</p></div>
        <select value={status} onChange={(e) => setStatus(e.target.value)} className="border border-stone/40 bg-bone px-3 py-1.5 text-sm">
          <option value="">All</option>{STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>
      <div className="border border-stone/30 bg-bone">
        <table className="w-full text-sm">
          <thead className="bg-bone-dim/40 text-[10px] uppercase tracking-[0.18em] text-brass">
            <tr><th className="text-left px-4 py-2.5">Created</th><th className="text-left px-4 py-2.5">Name</th><th className="text-left px-4 py-2.5">Email</th><th className="text-left px-4 py-2.5">Targets</th><th className="text-left px-4 py-2.5">Status</th><th className="text-right px-4 py-2.5"></th></tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.plan_id} className="border-t border-stone/20 hover:bg-bone-dim/20">
                <td className="px-4 py-2.5 text-stone text-xs">{r.created_at?.slice(0, 10)}</td>
                <td className="px-4 py-2.5 text-ink">{r.first_name || "—"}</td>
                <td className="px-4 py-2.5 text-ink-soft">{r.email}</td>
                <td className="px-4 py-2.5 text-[11px] text-stone">{(r.target_schools || []).join(", ")}</td>
                <td className="px-4 py-2.5">
                  <select value={r.status} onChange={(e) => setStat(r.plan_id, e.target.value)} className="text-[10px] uppercase tracking-[0.14em] border border-stone/40 bg-bone px-2 py-0.5" data-testid={`admin-plan-status-${r.plan_id}`}>
                    {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </td>
                <td className="px-4 py-2.5 text-right space-x-3">
                  <button onClick={() => open(r.plan_id)} className="text-[11px] uppercase tracking-[0.18em] text-ivy hover:text-brass">View</button>
                  <Link to={`/my-plan/${r.plan_id}`} target="_blank" className="text-[11px] uppercase tracking-[0.18em] text-stone hover:text-ivy">Public →</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {detail && (
        <div className="fixed inset-0 bg-ink/70 z-50 flex items-start justify-center py-10 px-4 overflow-y-auto" onClick={() => setDetail(null)}>
          <div className="bg-bone border border-stone/40 w-full max-w-3xl p-6 lg:p-8" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-baseline justify-between mb-6">
              <h2 className="font-serif text-2xl text-ivy tracking-tight">{detail.intake?.first_name || "Plan"} · {detail.plan_id.slice(-8)}</h2>
              <div className="flex items-center gap-3">
                <select value={detail.status || "new"} onChange={(e) => setStat(detail.plan_id, e.target.value)} className="text-[10px] uppercase tracking-[0.14em] border border-stone/40 bg-bone px-2 py-1" data-testid={`admin-plan-detail-status-${detail.plan_id}`}>
                  {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
                <button onClick={() => setDetail(null)} className="text-stone hover:text-ink text-2xl">×</button>
              </div>
            </div>
            <div className="space-y-6 max-h-[70vh] overflow-y-auto pr-2">
              <div><div className="text-[10px] uppercase tracking-[0.22em] text-brass font-semibold">Contact</div>
                <div className="text-sm text-ink mt-1">{detail.intake?.first_name} · {detail.intake?.email} · {detail.intake?.phone || "no phone"}</div>
              </div>
              <div><div className="text-[10px] uppercase tracking-[0.22em] text-brass font-semibold">Summary</div>
                <p className="text-sm text-ink mt-1 leading-relaxed">{detail.plan_json?.summary}</p>
              </div>
              <div><div className="text-[10px] uppercase tracking-[0.22em] text-brass font-semibold">Targets</div>
                <ul className="text-sm text-ink mt-1 space-y-1">
                  {(detail.plan_json?.target_school_assessments || []).map((a, i) => <li key={i}>• {a.institution_slug} — <span className="uppercase tracking-[0.14em] text-[10px] text-brass">{a.fit}</span> — {a.gpa_signal}</li>)}
                </ul>
              </div>
              <div><div className="text-[10px] uppercase tracking-[0.22em] text-brass font-semibold">Milestones</div>
                <ul className="text-sm text-ink mt-1 space-y-1">
                  {(detail.plan_json?.milestones || []).map((m, i) => <li key={i}>• [{m.when}] {m.title}</li>)}
                </ul>
              </div>
              <Link to={`/my-plan/${detail.plan_id}`} target="_blank" className="inline-block text-brass border-b border-brass hover:text-brass-soft text-sm">Open full plan →</Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
